module.exports = __webpack_public_path__ + "img/xp-tb-thunderboard.fd03acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-thunderboard.png
// module id = hegY
// module chunks = 39 44